<template>
  <div class="exhibition">
    <common-layout>
      <div slot="header">
        <h3>活动</h3>
      </div>
      <div class slot="container">
        <div class="exhibition.header">
          <el-button
            type="success"
            size="mini"
            class="exhibition.addBtn"
            @click="addActity()"
            >发布活动</el-button
          >
          <el-button
            type="info"
            size="mini"
            class="exhibition.addBtn"
            @click="exportOut"
            :disabled="tableData.length == 0"
            >导出</el-button
          >
          <section>
            <el-input
              placeholder="请输入活动名称"
              v-model="searchValue"
              class="input-with-select"
              clearable
              @clear="search"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="search"
              ></el-button>
            </el-input>
          </section>
          <div class="exhibition.header.item">
            <el-date-picker
              v-model="dateVal[0]"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="开始日期"
              @change="search('start')"
              style="width: 40%; margin: 0 5px 0 10px"
            >
            </el-date-picker>
            <span> - </span>
            <el-date-picker
              v-model="dateVal[1]"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="结束日期"
              @change="search('end')"
              style="width: 40%; margin: 0 10px 0 5px"
            >
            </el-date-picker>
            <!-- <el-date-picker
              v-model="dateVal"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="search"
            ></el-date-picker> -->
          </div>
          <div class="exhibition.header.item">
            <label>类型:</label>
            <el-select
              v-model="typeVal"
              placeholder="请选择"
              @change="search"
              clearable
            >
              <el-option label="全部" value></el-option>
              <el-option
                v-for="item in typeOptions"
                :key="item.id"
                :label="item.typeName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <!-- <div class="exhibition.header.item">
            <label>地点:</label>
            <el-select v-model="areaVal" placeholder="请选择">
              <el-option
                v-for="item in addressOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>-->
          <div class="exhibition.header.item">
            <label>状态:</label>
            <el-select
              v-model="statusVal"
              placeholder="请选择"
              @change="search"
              clearable
            >
              <el-option label="全部" value></el-option>
              <el-option label="未开始" :value="1"></el-option>
              <el-option label="进行中" :value="2"></el-option>
              <el-option label="已结束" :value="3"></el-option>
            </el-select>
          </div>
          <div class="exhibition.header.item">
            <label style="margin-right: 10px; line-height: 40px; min-width: 60px">发布平台:</label>
            <el-select
              style="width: 300px"
              v-model="srelease"
              clearable
              placeholder="请选择发布平台"
              @change="search"
            >
              <el-option label="双平台" :value="1" />
              <el-option label="大市场平台" :value="2" />
              <el-option label="成果交易平台" :value="3" />
            </el-select>
          </div>
        </div>
        <div class="exhibition.table">
          <el-table
            :data="tableData"
            stripe
            style="width: 100%"
            :header-cell-style="headerStyle"
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="90"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (current_page - 1) * per_page + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="活动名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="typeName"
              label="活动类型"
              align="center"
              width="90"
            ></el-table-column>
            <el-table-column label="活动时间" align="center">
              <template slot-scope="scope">
                <span
                  >{{ scope.row.startTime }} 至 {{ scope.row.endTime }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="place"
              label="活动地点"
              align="center"
            ></el-table-column>
            <!-- <el-table-column prop="region" label="发布部门" align="center"></el-table-column>
						<el-table-column label="报名人数" align="center">
							<template slot-scope="scope">
								<span>{{ scope.row.signUpAccount }}</span>
								<el-tag size="medium" @click="getSignUp(32)">详情</el-tag>
            </template>-->
            <!-- </el-table-column> -->
            <el-table-column label="报名/签到人数" align="center" width="150">
              <template slot-scope="scope">
                <span
                  >{{ scope.row.enrollNumber || 0 }} /
                  {{ scope.row.signNumber || 0 }}</span
                >&nbsp;
                <el-tag
                  size="medium"
                  @click="getCheck(scope.row.id, current_page, scope.row)"
                  style="background: #9853af; color: #fff"
                  >详情</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="活动状态"
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                <el-tag
                  type="warning"
                  v-show="new Date(scope.row.startTime) > new Date()"
                  >未开始</el-tag
                >
                <el-tag
                  type="success"
                  v-show="
                    new Date() >= new Date(scope.row.startTime) &&
                    new Date() <= new Date(scope.row.endTime)
                  "
                  >进行中</el-tag
                >
                <el-tag
                  type="info"
                  v-show="new Date(scope.row.endTime) < new Date()"
                  >已结束</el-tag
                >
              </template>
            </el-table-column>
            <!-- <el-table-column label="签到二维码" width="150" align="center">
              <template slot-scope="scope">
                <span class="code-img">
                  <img :src="scope.row.codeImg" alt />
                </span>
              </template>
            </el-table-column>-->
            <el-table-column
              label="签到二维码"
              align="center"
              class-name="code"
            >
              <template slot-scope="scope">
                <div @click="qart(scope.row)" style="cursor: pointer">
                  <vue-q-art
                    :config="{
                      value: '{id=' + scope.row.id + '}',
                      imagePath: require('../../assets/zz.jpg'),
                      filter: 'color',
                      size: 100,
                    }"
                  ></vue-q-art>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="organization"
              label="主办单位"
              align="center"
            ></el-table-column>
            <el-table-column label="意见" align="center">
              <template slot-scope="scope">
                <el-tag
                  size="medium"
                  @click="showAdvice(scope.row.id)"
                  style="background: #9853af; color: #fff"
                  >详情</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column label="发布平台" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.isAchievement === 1 && scope.row.isMarket === 1
                    ? '双平台'
                    : scope.row.isMarket === 1
                    ? '大市场平台'
                    : '成果交易平台'
                }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="250">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button
                    style="margin-bottom: 5px"
                    size="mini"
                    @click="openActityModal(scope.$index, scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    style="margin-bottom: 5px"
                    type="warning"
                    size="mini"
                    @click="release(scope.row)"
                    v-if="scope.row.isShow == 2"
                    >取消发布</el-button
                  >
                  <el-button
                    style="margin-bottom: 5px"
                    type="primary"
                    size="mini"
                    @click="release(scope.row)"
                    v-else
                    >确定发布</el-button
                  >
                  <el-button
                    style="margin-bottom: 5px"
                    type="danger"
                    size="mini"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                  <!-- <el-button size="mini" type="primary" @click="again(scope.$index, scope.row)">再次发布</el-button> -->
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <div class="grid-content bg-purple-light">
            <el-pagination
              @current-change="handleCurrentChange"
              :hide-on-single-page="true"
              layout="total, prev, pager, next,jumper"
              :total="total"
              :current-page.sync="current_page"
              :page-size="per_page"
            ></el-pagination>
          </div>
        </div>
      </div>
    </common-layout>
    <!-- 发布活动 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogActityFormVisible"
      width="60%"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form
        :model="formActity"
        class="demo-ruleForm"
        :rules="ActityRules"
        ref="ActityRuleForm"
      >
        <section class="exhibition.item">
          <div class="row1">
            <el-form-item
              label="活动名称:"
              :label-width="formLabelWidth"
              prop="name"
            >
              <el-input
                v-model="formActity.name"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="活动封面:"
              :label-width="formLabelWidth"
              prop="image"
            >
              <!-- <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/" :show-file-list="false" :on-success="handleAvatarSuccess">
								<img v-if="formActity.img" :src="formActity.img" class="avatar" />
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>-->

              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
              >
                <img
                  v-if="formActity.image"
                  :src="imgUrl + formActity.image"
                  class="img_border"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !formActity.image }"
                ></i>
                <span class="upload_btn" v-if="!formActity.image"
                  >上传图片</span
                >
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="formActity.image">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </div>
          <div class="row2">
            <!-- <el-form-item label="是否首页显示:" :label-width="formLabelWidth" prop="isShowInHome">
							<el-radio-group v-model="formActity.isShowInHome">
								<el-radio label="是"></el-radio>
								<el-radio label="否"></el-radio>
							</el-radio-group>
            </el-form-item>-->
            <el-form-item
              label="活动时间:"
              :label-width="formLabelWidth"
              class="rowTime"
              prop="time"
            >
              <el-date-picker
                style="width: 100%"
                v-model="formActity.time"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              label="是否允许报名:"
              :label-width="formLabelWidth"
              prop="isEnroll"
            >
              <el-radio-group v-model="formActity.isEnroll">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="是否短信通知:" :label-width="formLabelWidth" prop="isSendMessage">
              <el-radio-group v-model="formActity.isSendMessage">
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
              </el-radio-group>
            </el-form-item>-->
            <!-- <el-form-item label="是否签到:" :label-width="formLabelWidth" prop="isSignUp">
              <el-radio-group v-model="formActity.isSignUp">
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
              </el-radio-group>
            </el-form-item>-->
          </div>
        </section>
        <section class="exhibition.item">
          <el-form-item
            label="活动类型:"
            :label-width="formLabelWidth"
            class="rowLine +add-button"
            prop="typeId"
          >
            <el-select
              v-model="formActity.typeId"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.id"
                :label="item.typeName"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-button type="primary" size="mini" @click="addActityType"
              >+新增</el-button
            >
          </el-form-item>

          <el-form-item
            label="限制人数:"
            :label-width="formLabelWidth"
            class="rowLine"
          >
            <el-input
              v-model="formActity.number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </section>

        <el-form-item
          label="联系人:"
          :label-width="formLabelWidth"
          class="rowLine"
          prop="author"
        >
          <el-input
            v-model="formActity.author"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="联系电话:"
          :label-width="formLabelWidth"
          class="rowLine"
          prop="contact"
        >
          <el-input
            v-model="formActity.contact"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="活动地点:"
          :label-width="formLabelWidth"
          prop="place"
          class="rowLine"
        >
          <el-input
            v-model="formActity.place"
            placeholder="请输入内容"
            @keyup.native="factory"
          ></el-input>
          <!-- <el-select v-model="formActity.place" filterable placeholder="请选择">
            <el-option
              v-for="item in addressOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>-->
        </el-form-item>
        <el-form-item
          label="主办单位"
          :label-width="formLabelWidth"
          prop="organization"
          class="rowLine"
        >
          <el-input
            v-model="formActity.organization"
            placeholder="请输入主办单位"
          ></el-input>
        </el-form-item>

        <section class="exhibition.map">
          <el-form-item
            label="是否展示地图:"
            :label-width="formLabelWidth"
            prop="isMap"
          >
            <el-radio-group v-model="formActity.isMap">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="取经维度网址:" :label-width="formLabelWidth">
						<a href="https://lbs.amap.com/console/show/picker" target="_blank">高德开放平台</a>
          </el-form-item>-->
        </section>
        <!-- <el-row>
					<el-col :span="12">
						<el-form-item label="经度展示(默认大市场):" label-width="178px" class="rowMap" prop="longitude">
							<el-input placeholder="请输入经度" v-model="formActity.longitude" class="rowLon"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="纬度展示(默认大市场):" label-width="178px" class="rowMap" prop="latitude">
							<el-input placeholder="请输入纬度" v-model="formActity.latitude" class="rowLon"></el-input>
						</el-form-item>
					</el-col>
        </el-row>-->

        <el-form-item label="活动详情:" :label-width="formLabelWidth">
          <editor
            style="text-align: left"
            v-model="formActity.introduction"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
          ></editor>
          <!-- <editor
            style="text-align:left"
            :quillData="formActity.introduction"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
            @getQuillData="getQuillData"
          ></editor>-->
        </el-form-item>
        <el-form-item
          label="活动回顾:"
          :label-width="formLabelWidth"
          v-show="isShowMember"
        >
          <el-upload
            style="text-align: left"
            :action="this.uploadURL"
            list-type="picture-card"
            :file-list="fileList"
            :on-success="handleFilePreview"
            :on-preview="pictureCardPreview"
            :before-upload="beforeUpload"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="同步发布:"
            :label-width="formLabelWidth" prop="isMarket" style="text-align: left">
          <el-select
            v-model="isMarket"
            placeholder="请选择"
            style="width: 100%"
            @change="formmarket"
          >
            <el-option label="双平台" :value="1" />
            <el-option label="大市场平台" :value="2" />
            <el-option label="成果交易平台" :value="3" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="confirmCreate">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <!-- 添加活动类型 -->
    <el-dialog
      :visible.sync="dialogTypeVisible"
      title="活动类型"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form :model="acTypeForm" :rules="acTypeFormRule" ref="acTypeForm">
        <el-form-item
          label="类型名称"
          :label-width="formLabelWidth"
          prop="typeName"
        >
          <el-input
            v-model="acTypeForm.typeName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTypeVisible = false">取 消</el-button>
        <el-button type="primary" @click="createActityType"
          >确 定 添 加</el-button
        >
      </div>
    </el-dialog>
    <!-- 活动意见 -->
    <el-dialog
      title="活动意见"
      :visible.sync="dialogAdviceVisible"
      :close-on-click-modal="false"
    >
      <el-table
        :data="adviceData"
        stripe
        style="width: 100%"
        :header-cell-style="headerStyle"
      >
        <el-table-column type="index" label="序号" align="center" width="90">
          <template slot-scope="scope">
            <span>{{
              scope.$index + (person_current_page - 1) * person_per_page + 1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="username"
          label="发表人"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          property="dateTime"
          label="发表时间"
          align="center"
        ></el-table-column>
        <el-table-column
          property="phone"
          label="手机号"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          property="content"
          label="内容"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <div class="grid-content bg-purple-light">
          <el-pagination
            @current-change="handlePersonCurrentChange"
            :hide-on-single-page="true"
            layout="total, prev, pager, next,jumper"
            :total="person_total"
            :current-page.sync="person_current_page"
            :page-size="person_per_page"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 二维码 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogQartVisible"
      :fullscreen="true"
      :show-close="false"
      class="ercode"
    >
      <template slot="title">
        签到二维码
        <span
          style="cursor: pointer; position: absolute; right: 42px"
          @click="
            dialogQartVisible = !dialogQartVisible;
            exitFullScreen();
          "
          >退出</span
        >
      </template>
      <div
        class="qart"
        :style="{
          'margin-top': qrcodeTopHeight + 'px',
          'text-align': 'center',
        }"
      >
        <p style="font-size: 24px">{{ fieldForm.name }}</p>
        <span style="font-size: 16px; color: #999; position: relative">
          <img
            :src="images[0]"
            style="width: 18px; position: absolute; left: -25px; top: 3px"
            alt
          />
          {{ fieldForm.startTime + " 至 " + fieldForm.endTime }}
        </span>
        <div
          id="qrcode"
          style="display: flex; justify-content: center; margin-top: 20px"
        ></div>
        <div style="font-size: 30px; margin-top: 30px">
          扫描上方二维码活动签到
        </div>

        <div class="print">
          <a
            id="downloadA"
            :href="downloadQR"
            :download="'二维码-' + fieldForm.name"
            style="cursor: pointer"
            target="_blank"
          >
            <img
              :src="images[1]"
              style="width: 18px; margin-right: 20px; cursor: pointer"
              alt
              @click="downloadQrcode"
            />
          </a>
          <img
            :src="images[2]"
            style="width: 18px; cursor: pointer"
            alt
            @click="printQrcode"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import CommonLayout from "../../components/common-layout.vue";
// import editor from "../../components/yhQuillEditor";
import editor from "../../components/tinymce-editor/tinymce-editor";
import VueQArt from "vue-qart"; //二维码
import QRCode from "qrcodejs2";
import {CheckTimeLine} from '../../utils/tool'
import {download1} from "@/utils/download";
export default {
  components: {
    CommonLayout,
    editor,
    VueQArt,
    QRCode,
  },
  data() {
    return {
      is_submit: true,
      active_id: "",
      isShowMember: false, //是否展示活动回顾上传照片
      dialogAdviceVisible: false, //活动意见
      adviceData: [],
      dialogTypeVisible: false,
      dialogImageUrl: "",
      dialogVisible: false,
      title: "",
      total: 20,
      current_page: 1,
      per_page: 10,
      person_total: 10,
      person_current_page: 1,
      person_per_page: 10,
      fileList: [],
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      acTypeForm: {
        typeName: "",
      },
      acTypeFormRule: {
        typeName: [
          {
            required: true,
            message: "请填写类型名称",
            trigger: "blur",
          },
        ],
      },
      typeVal: "",
      areaVal: "",
      dateVal: [],
      statusVal: "",
      srelease: '',
      dialogActityFormVisible: false, //发布活动
      formLabelWidth: "120px",
      typeOptions: [],
      addressOptions: [
        {
          label: "地点1",
          value: "类型1",
        },
        {
          label: "地点2",
          value: "类型2",
        },
        {
          label: "地点3",
          value: "地点3",
        },
        {
          label: "地点4",
          value: "类型4",
        },
      ],
      isMarket:1,
      formActity: {
        image: "", //封面图
        // isShowInHome: "是", //是否展示在首页
        // isSendMessage: "是", //是否发送短信通知
        // isSignUp: "是", //是否签到
        isEnroll: 1, //是否允许报名
        name: "", //活动名称
        time: "", //活动时间
        startTime: "", //开始时间
        endTime: "", //结束时间
        author: "", //联系人
        contact: "", //联系电话
        typeId: "", //活动类型
        number: "", //活动人数
        place: "", //活动地址
        isMap: 1, //是否展示地图
        longitude: "", //经度维度
        latitude: "", //纬度维度
        introduction: "", //说明
        isShow: 2,
        review: "",
        organization: "",
        isMarket: 1,
        isAchievement: 1,
      },
      ActityRules: {
        image: [
          {
            required: true,
            message: "请上传封面图片",
            trigger: "blur",
          },
        ],
        // isShowInHome: [
        //   { required: true, message: "请选择是否在首页展示", trigger: "change" }
        // ],
        // isSendMessage: [
        //   { required: true, message: "请选择是否短信通知", trigger: "change" }
        // ],
        // isSignUp: [
        //   { required: true, message: "请选择是否签到", trigger: "change" }
        // ],
        isEnroll: [
          {
            required: true,
            message: "请选择是否允许报名",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入活动名称",
            trigger: "blur",
          },
        ],
        typeId: [
          {
            required: true,
            message: "请选择活动类型",
            trigger: "change",
          },
        ],
        time: [
          {
            required: true,
            message: "请选择活动时间",
            trigger: "blur",
          },
        ],
        author: [
          {
            required: true,
            message: "请输入联系人姓名",
            trigger: "blur",
          },
        ],
        contact: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur",
          },
        ],
        place: [
          {
            required: true,
            message: "请选择活动地址",
            trigger: "change",
          },
        ],
        isMap: [
          {
            required: true,
            message: "请选择是否展示地图",
            trigger: "change",
          },
        ],
        // longitude: [{ required: true, message: "请填写经纬度", trigger: "blur" }]
      },
      searchValue: "",
      tableData: [],
      fieldForm: {},
      downloadQR: "",
      dialogQartVisible: false,
      qrcodeTopHeight: "",
      images: [
        require("../../assets/icon1.png"),
        require("../../assets/icon5.png"),
        require("../../assets/icon6.png"),
      ],
    };
  },
  created() {
    this.getData(`Active?page=${window.localStorage.getItem("page")}`);
    this.getActityType();
  },
  methods: {
    formmarket(val) {
      if (val === 1) {
        this.formActity.isMarket = 1;
        this.formActity.isAchievement = 1;
      } else if (val === 2) {
        this.formActity.isMarket = 1;
        this.formActity.isAchievement = 2;
      } else {
        this.formActity.isMarket = 2;
        this.formActity.isAchievement = 1;
      }
    },
    //导出
    exportOut() {
      /*let url = window.urlConfig.url + "export_Active_List";
      var a = document.createElement("a");
      a.href = url;
      a.download = "";
      a.click();*/
      download1(`${urlConfig.devUrl}apij2/admin-api/trade/active/export-excel`, "活动.xls")
    },
    //二维码
    qart(data) {
      this.fieldForm = data;
      this.dialogQartVisible = !this.dialogQartVisible;

      this.$nextTick(() => {
        document.getElementById("qrcode").innerHTML = "";
        if (document.getElementById("qrcode").childNodes.length > 0) {
          new QRCode(document.getElementById("qrcode")).makeCode(
            "id=" + data.id
          ); // make another code.
        } else {
          var qrcode = new QRCode(document.getElementById("qrcode"), {
            text: "id=" + data.id,
            width: 512,
            height: 512,
          });
        }
        //加logo
        let ctx = document.getElementById("qrcode").firstChild.getContext("2d");
        let img = new Image();
        img.onload = function () {
          ctx.drawImage(img, 175, 164);
        };
        // img.src = "../../../static/taida.png";
        img.width = "200px";
        //显示二维码-canvas delete<img>
        setTimeout(() => {
          document.getElementById("qrcode").firstChild.style.display = "block";
          document
            .getElementById("qrcode")
            .lastChild.parentNode.removeChild(
              document.getElementById("qrcode").lastChild
            );
          this.downloadQrcode(); //下载二维码
        }, 100);
        this.qrcodeTopHeight = (window.innerHeight - 700) / 2;
      });
      this.fullScreen();
    },
    downloadQrcode() {
      let canvas = document.getElementById("qrcode").firstChild;
      let save_url = canvas.toDataURL("image/png");
      this.downloadQR = save_url;
    },
    printQrcode() {
      let oldContent = document.body.innerHTML;
      let img = new Image();
      let imgUrl = $("#qrcode")[0].firstChild.toDataURL("image/png");
      img.src = imgUrl;
      let div = document.createElement("div");

      div.id = "qrcodeCopy";
      div.style = "display:flex;justify-content: center;width: 100%;";
      $("#qrcode").append(div);
      $("#qrcode canvas").remove();
      $("#qrcodeCopy").append(img);

      setTimeout(() => {
        $(".print").css("display", "none");
        $("body").css("height", "700px"); //打印第一页
        document.body.innerHTML = document.getElementsByClassName(
          "el-dialog__body"
        )[0].innerHTML;

        window.print();
        window.location.reload();
        document.body.innerHTML = oldContent;
        return false;
      }, 100);
    },
    fullScreen() {
      var el = document.documentElement;

      var rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen;

      if (typeof rfs != "undefined" && rfs) {
        rfs.call(el);
      } else if (typeof window.ActiveXObject != "undefined") {
        //for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏

        var wscript = new ActiveXObject("WScript.Shell");

        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    },

    exitFullScreen() {
      var el = document;

      var cfs =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullScreen;

      if (typeof cfs != "undefined" && cfs) {
        cfs.call(el);
      } else if (typeof window.ActiveXObject != "undefined") {
        //for IE，这里和fullScreen相同，模拟按下F11键退出全屏

        var wscript = new ActiveXObject("WScript.Shell");

        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    //获取经纬度
    factory() {
      if (this.formActity.place) {
        this.$jsonp(
          "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
            this.formActity.place +
            "&city=兰州&children=1&offset=20&page=1&extensions=all"
        )
          .then((json) => {
            let arr = json.pois[0].location.split(",");
            this.formActity.longitude = arr[0];
            this.formActity.latitude = arr[1];
          })
          .catch((err) => {
            this.$message.error("未获取到经纬度");
          });
      }
    },
    // 添加活动类型
    addActityType() {
      this.dialogTypeVisible = true;
      this.acTypeForm.typeName = "";
    },
    // 创建活动类型
    createActityType() {
      this.$refs["acTypeForm"].validate((valid) => {
        if (valid) {
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/trade/active-type/create`, this.acTypeForm)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("添加成功");
                this.dialogTypeVisible = false;
                this.getActityType();
              }
            })
            .catch((error) => {
              this.$message.error(res.status);
            });
        }
      });
    },
    // 获取活动类型数据
    getActityType() {
      this.http
        .post(`${urlConfig.devUrl}apij2/admin-api/trade/active-type/listAll`, {})
        .then((res) => {
          //console.log(res.data.data)
          this.typeOptions = res.data;
        })
        .catch((error) => {});
    },
    //搜索
    search(type="") {
      if (this.dateVal.filter((d) => d).length === 2) {
        let flag = CheckTimeLine(this.dateVal[0], this.dateVal[1]);

        if (flag) {
          if (type === "start") {
            this.$set(this.dateVal, 0, "");
          } else {
            this.$set(this.dateVal, 1, "");
          }

          return false;
        }
      }
      let typeId = this.typeVal ? `&typeId=${this.typeVal}` : "";
      let status = this.statusVal ? `&status=${this.statusVal}` : "";
      if (this.dateVal) {
        this.getData(
          `Active?name=${this.searchValue}&startTime=${
            this?.dateVal[0] || ""
          }&endTime=${this?.dateVal[1] || ""}${typeId}${status}${
            (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
            // this.srelease !==1 ? (this.srelease === 2 ? '&isMarket=1' : '&isAchievement=1') : ''
          }`
        );
      } else {
        this.getData(`Active?name=${this.searchValue}${typeId}${status}${
            (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
          }`);
      }
    },
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/active/page2`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.current_page = res.data.current_page;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
        }
      });
    },
    //富文本
    getQuillData(val) {
      this.formActity.introduction = val;
    },
    //选择页码
    handleCurrentChange(e) {
      this.current_page = e;

      this.getData(
        `Active?page=${this.current_page}&typeId=${this.typeVal}&status=${
          this.statusVal
        }&name=${this.searchValue}&startTime=${
          this?.dateVal[0] || ""
        }&endTime=${this?.dateVal[1] || ""}${
          (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
        }`
      );
    },
    /* 确定发布活动 */
    confirmCreate() {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.$refs["ActityRuleForm"].validate((valid) => {
        let obj = JSON.parse(JSON.stringify(this.formActity));
        let arr = [];
        obj.startTime = obj.time[0];
        obj.endTime = obj.time[1];
        this.fileList.forEach((item) => {
          if (item.response) {
            arr.push(item.response.data.store_result);
          } else {
            arr.push(item.store_result);
          }
        });
        obj.review = arr.join(",");
        if (valid) {
          if (!obj.id) {
            delete obj.time;
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/active/create`, obj)
              .then((res) => {
                if (res.code == 0) {
                  this.ResetSearch([
                    "searchValue",
                    "typeVal",
                    "statusVal"
                  ]);
                  this.srelease = 1
                  this.dateVal = []
                  this.$message.success("新建成功！");
                  this.isMarket = 1
                  this.search();
                  this.fileList = [];
                  this.dialogActityFormVisible = false;
                } else {
                  this.$message.error(res.status);
                }
              })
              .catch((err) => {
                this.is_submit = true;
              });
          } else {
            // delete obj.id;
            delete obj.time;
            obj.id = this.formActity.id;
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/active/update`, obj)
              .then((res) => {
                if (res.code == 0) {
                  this.ResetSearch([
                    "searchValue",
                    "typeVal",
                    "statusVal",
                  ]);
                  this.srelease = 1
                  this.dateVal = []
                  this.$message.success("编辑成功！");
                  this.isMarket = 1
                  try {
                    this.search();
                  } catch(ele){
                    console.log(ele)
                  }
                  this.dialogActityFormVisible = false;
                  this.fileList = [];
                } else {
                  this.$message.error(res.status);
                }
              })
              .catch((err) => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;

          return false;
        }
      });
    },
    // 新建
    addActity() {
      this.isShowMember = false;
      this.dialogActityFormVisible = true;
      this.title = "新建活动";
      this.fileList = [];
      this.isMarket = 1
      this.formActity = {
        image: "",
        // isShowInHome: "是", //是否展示在首页
        // isSendMessage: "是", //是否发送短信通知
        // isSignUp: "是", //是否签到
        isEnroll: 1, //是否允许报名
        name: "", //活动名称
        time: "", //活动时间
        startTime: "", //开始时间
        endTime: "", //结束时间
        author: "", //联系人
        contact: "", //联系电话
        typeId: "", //活动类型
        number: "", //活动人数
        place: "", //活动地址
        isMap: 1, //是否展示地图
        longitude: "", //经度维度
        latitude: "", //纬度
        introduction: "", //说明
        isShow: 2,
        review: "",
        organization: "",
        isMarket: 1,
        isAchievement: 1,
      };
    },
    /* 打开编辑发布活动弹窗 */
    async openActityModal(index, row) {
      await this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/active/get?id=`+row.id).then((res) => {
        if (res.code == 0) {
          row = res.data;
        }
      });

      let time = [];
      if (new Date(row.endTime) < new Date()) {
        this.isShowMember = true;
      } else {
        this.isShowMember = false;
      }
      time[0] = row.startTime;
      time[1] = row.endTime;
      this.dialogActityFormVisible = true;
      this.title = "编辑活动";
      this.isMarket =
      row.isAchievement === 1 && row.isMarket === 1
          ? 1
          : row.isMarket === 1
          ? 2
          : 3;
      this.formActity = {
        id: row.id,
        image: row.image,
        // isShowInHome: "是", //是否展示在首页
        // isSendMessage: "是", //是否发送短信通知
        // isSignUp: "是", //是否签到
        isEnroll: row.isEnroll, //是否允许报名
        name: row.name, //活动名称
        time: time, //活动时间
        startTime: row.startTime, //开始时间
        endTime: row.endTime, //结束时间
        author: row.author, //联系人
        contact: row.contact, //联系电话
        typeId: row.typeId, //活动类型
        number: row.number, //活动人数
        place: row.place, //活动地址
        isMap: row.isMap, //是否展示地图
        longitude: row.longitude, //经度维度
        latitude: row.latitude, //经度维度
        introduction: row.introduction, //说明
        isShow: row.isShow,
        review: row.review,
        organization: row.organization,
        isMarket : row.isMarket,
        isAchievement : row.isAchievement
      };
      this.fileList = [];
      if (row.review) {
        let arr = [];
        arr = row.review.split(",");
        arr.forEach((item, index) => {
          this.fileList.push({
            name: "download.jpg",
            url: this.imgUrl + item,
            store_result: item,
            uid: new Date().getTime() + index,
          });
        });
      }
    },
    //取消发布
    release(row) {
      // 1未发布 2已发布 3已取消发布 4已结束',
      let isShow;
      let tips;
      if (row.isShow == 2) {
        isShow = 3;
        tips = "取消";
      } else {
        isShow = 2;
        tips = "发布";
      }
      this.$confirm(`确定${tips}吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/trade/active/update` ,
                {
                  id: row.id,
                  isShow: isShow
                }
            )
            .then((res) => {
              if (res.code == 0) {
                this.$message.success(tips + "成功");
                this.search();
                this.dialogActityFormVisible = false;
              } else {
                this.$message.error(res.status);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //删除
    handleDelete(index, row) {
      if (row.enroll_number) {
        this.$message.warning("已有人报名不能删除");
        return false;
      }
      if (row.sign_number) {
        this.$message.warning("已有人签到不能删除");
        return false;
      }
      this.$confirm("确定删除文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http.request(`${urlConfig.devUrl}apij2/admin-api/trade/active/delete?id=` + row.id, "", "delete").then(
            (response) => {
              if (response.code == 0) {
                this.ResetSearch([
                  "searchValue",
                  "typeVal",
                  "statusVal",
                ]);
                this.dateVal = []
                this.$message.success("删除成功！");
                this.search();
              } else {
                this.$message.error(response.status);
              }
            },
            (error) => {}
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //再次发布
    again() {},
    // 报名人数
    getSignUp(id) {
      this.$router.push({
        path: `/${this.$route.fullPath.split('/')[1]}/active/${id}`,
      });
    },
    // 签到人数
    getCheck(id, page, item) {
      window.localStorage.setItem("page", page);
      this.$router.push({
        path: `/${this.$route.fullPath.split('/')[1]}/active/${id}?isShow=${
          new Date(item.endTime) < new Date() ? 4 : item.isShow
        }&isEnroll=${item.isEnroll}`,
      });
    },
    //取消
    close() {
      this.dialogActityFormVisible = false;
      this.$refs["ActityRuleForm"].resetFields();
      this.fileList = [];
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.formActity.image = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },

    handlePictureCardPreview(file) {
      this.formActity.image = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.formActity.image;
      img.onload = function () {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.formActity.image = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //回顾
    //上传
    handleFilePreview(response, file, fileList) {
      if (response.code == 0) this.fileList = fileList;
      else this.$message.warning(`上传失败！！！`);
    },
    //移除
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    //上传前
    beforeUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    //查看
    pictureCardPreview(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //查看意见
    showAdvice(id) {
      this.dialogAdviceVisible = true;
      this.active_id = id;
      this.getAdvice(`Active_Suggest?activeId=${id}`);
    },
    handlePersonCurrentChange(val) {
      this.person_current_page = val;
      this.getAdvice(
        `Active_Suggest?activeId=${this.active_id}&page=${this.person_current_page}`
      );
    },
    getAdvice(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/active-suggest/page2`, params)
      .then((res) => {
          this.adviceData = res.data.data;
          this.person_current_page = res.data.current_page;
          this.person_total = res.data.total;
          this.person_per_page = res.data.per_page;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@include component(exhibition) {
  width: 100%;
  height: 100%;

  @include tweak(add-button) {
    @include component(el-form-item__content) {
      display: flex;
      justify-content: flex-start;
    }

    @include component(el-select) {
      width: 220px;
      margin-right: 15px;
    }
  }

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    > section {
      margin-right: 20px;

      @include component(el-input) {
        width: 260px;
      }
    }

    @include part(item) {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      > label {
        width: 70px;
        display: inline-block;
      }

      &:nth-of-type(2) {
        margin-left: 30px;
      }

      @include component(el-input) {
        width: 100px;
      }

      @include component(el-range-separator) {
        padding: 0;
      }
    }
  }

  @include part(addBtn) {
    &:nth-child(2) {
      margin-right: 10px;
    }

    &:nth-child(1) {
      background: #623aa2 !important;
      color: #fff;
      border: none;
    }
  }

  @include part(table) {
    margin-top: 30px;
    width: 100%;
  }

  @include component(code-img) {
    display: inline-block;
    width: 80px;
    height: 80px;

    img {
      width: 100%;
      display: block;
    }
  }

  // @include component(avatar-uploader) {
  // 	width: 200px;
  // }
  @include component(el-form-item) {
  }

  @include part(item) {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @include component(el-radio-group) {
      width: 100%;
      text-align: left;
    }
  }

  @include component(row1) {
    width: 48%;
    display: flex;
    flex-direction: column;
  }

  @include component(row2) {
    width: 48%;
    display: inline-block;

    &:nth-child(2n) {
      margin-left: 2%;
    }
  }

  @include component(rowTime) {
    width: 100%;
  }

  @include component(rowLine) {
    display: inline-block;
    width: 50%;
  }

  @include component(el-select) {
    width: 100%;
  }

  @include part(map) {
    display: flex;
    justify-content: flex-start;

    @include component(el-radio-group) {
      width: 100%;
      text-align: left;
    }

    @include component(rowLink) {
      width: 30%;
    }

    .rowMap {
      width: 40%;

      &:nth-child(2) {
        width: 60%;

        @include component(el-form-item__content) {
          display: flex;
          justify-content: space-around;

          @include component(el-input) {
            width: 40%;
          }
        }
      }
    }

    .rowLon {
      width: 50%;
      display: inline-block;
    }
  }

  @include component(rowRegion) {
    width: 50%;
  }

  .pagination {
    margin-top: 10px;
    text-align: left;
  }

  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 198px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
  /deep/.cell canvas {
    height: 65px;
  }

  .print {
    border-top: #e2e2e2 1px solid;
    height: 20px;
    position: fixed;
    bottom: 34px;
    width: 100%;
    left: 0;
    padding-top: 55px;
  }
  .ercode {
    /deep/.el-dialog__header {
      padding: 20px 32px 10px;
      font-weight: bold;
      background-color: #f2f3f5;
      font-size: 16px;
    }
  }
}
</style>
